import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';

const NumberInput = ({ label, min, max, value, onChange }) => {
    const intl = useIntl();
    const message = intl.formatMessage({ id: label });
    const [inputValue, setInputValue] = useState(value);

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const handleChange = (e) => {
        const newValue = e.target.value;
        
        // Allow empty string for better UX while typing
        if (newValue === '') {
            setInputValue('');
            return;
        }
        
        // Only allow numeric input
        if (/^\d+$/.test(newValue)) {
            const numericValue = Number(newValue);
            
            // Enforce min/max limits
            if (numericValue >= min && numericValue <= max) {
                setInputValue(newValue);
                onChange({ target: { value: numericValue } });
            }
        }
    };

    const handleBlur = () => {
        // If field is empty or invalid on blur, reset to current valid value
        if (inputValue === '' || Number(inputValue) < min || Number(inputValue) > max) {
            setInputValue(value);
        }
    };

    const handleKeyDown = (e) => {
        // Prevent decimal point, minus sign, and other non-numeric keys
        if (e.key === '.' || e.key === '-' || e.key === 'e' || e.key === 'E') {
            e.preventDefault();
        }
    };

    const handlePaste = (e) => {
        const pasteData = e.clipboardData.getData('Text');
        // Prevent pasting non-numeric values
        if (/[^0-9]/.test(pasteData)) {
            e.preventDefault();
        }
    };

    const handleFocus = (e) => {
        e.target.select();
    };

    return (
        <>
            <label className="col-form-label mes-from-label-1 fw-semibold" htmlFor="rotation" dangerouslySetInnerHTML={{ __html: message }} />
            <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                className="form-control h-54 bg-baby-blue"
                name="rotation"
                value={inputValue}
                onChange={handleChange}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
                onPaste={handlePaste}
                onFocus={handleFocus}
                placeholder={`${min}-${max}`}
            />
        </>
    );
};

export default NumberInput;